<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Bénévoles " />
            <BeneVoles />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import BeneVoles from '../Benevole/BeneVoles.vue'


export default {
    name: 'BenevolePage',
    components: {
        NavBar,
        PageTitle,
        BeneVoles,
        FooterComp,
    }
}
</script>